import React, { useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import InfoIcon from "@mui/icons-material/Info";
import Tooltip from "@mui/material/Tooltip";

import styles from "../components/ARWebBilling.module.css";

import "./../assets/css/custom.css";

import i18next from "../constants/i18n";
import { formatCurrency } from "../utils/utils";

let fontStyle1 = {
  temp1: {},
  temp2: {
    fontFamily: "GilroySemiBold !important",
  },
};

const ARWebBilling = (props) => {
  const [openTooltip, setOpenTooltip] = useState(null);

  let {
    totalCartPrice,
    subTotal,
    tipValue,
    restTemplate,
    restData,
    discountAmount,
    couponDiscountAmount,
    orderType,
    couponName,
    themeColors = {},
  } = props;

  const {
    checkoutCardsBgColor = null,
    checkoutBillingPriceFontSize = null,
    checkoutBillingTotalPriceFontSize = null,
    checkoutFontColor = null,
  } = themeColors || {};
  const paymentGateway = restData?.paymentSettings?.tableOrder?.defaultGateway ?? 'stripe'

  // Only show charges if payment gateway is not direct
  const charges = paymentGateway === 'direct' ? [] : restData?.charges?.map((charge) => {
    if (charge.isActive && charge.orderType + '' === orderType + '')
      return {
        label: charge.name,
        value: charge.isPercentage
          ? (subTotal * charge.value) / 100
          : charge.value,
        customerVisibleMessage: charge.customerVisibleMessage,
      };
    return null;
  }).filter(Boolean) ?? [];

  let billingList = [
    {
      label: i18next.t("Subtotal"),
      value: subTotal,
    },
    ...charges,
  ];

  // Only show tip if payment gateway is not direct
  if (tipValue && paymentGateway !== 'direct') {
    billingList.push({
      label: i18next.t("Tip"),
      value: tipValue,
    });
  }

  return (
    <Grid item mx={props.page === "checkout" ? 2 : 1} pb={3} mt={1.5}>
      <Box
        p={2}
        sx={{
          backgroundColor:
            (props.page === "checkout" && checkoutCardsBgColor) ??
            "transparent",
        }}
        className={styles.mainView}
      >
        {billingList.map((x, i) =>
          x?.value > 0 ? (
            <Box key={i} className={styles.listView} mb={1}>
              <Box className={styles.labelView}>
                <Typography
                  className={styles.labelText}
                  sx={{ color: `${checkoutFontColor ?? "#000"} !important` }}
                >
                  {x.label}
                </Typography>
                {x.customerVisibleMessage && (
                  <Tooltip
                    title={x.customerVisibleMessage}
                    open={openTooltip === `charge-${i}`}
                    onClose={() => setOpenTooltip(null)}
                    disableHoverListener
                    disableFocusListener
                    placement="top"
                    arrow={false}
                    slotProps={{
                      tooltip: {
                        style: {
                          marginBottom: '4px',
                          fontSize: '12px',
                          maxWidth: '200px'
                        }
                      }
                    }}
                  >
                    <IconButton
                      size="small"
                      sx={{ ml: 0.5, color: checkoutFontColor ?? "#000", padding: "2px" }}
                      onClick={() => setOpenTooltip(openTooltip === `charge-${i}` ? null : `charge-${i}`)}
                    >
                      <InfoIcon fontSize="inherit" sx={{ fontSize: "14px" }} />
                    </IconButton>
                  </Tooltip>
                )}
              </Box>
              <Typography
                className={styles.billVal}
                sx={{
                  fontSize: `${checkoutBillingPriceFontSize ?? "16"}px`,
                  color: `${checkoutFontColor ?? "#000"} !important`,
                }}
              >
                {/* {currency} */}
                {formatCurrency(x.value)}
              </Typography>
            </Box>
          ) : null
        )}
        {discountAmount > 0 && (<Box className={styles.listView} mb={1}>
          <Box className={styles.labelView}>
            <Typography
              className={styles.labelText}
              sx={{
                color: `${checkoutFontColor ?? "#000"} !important`,
              }}
            >
              {i18next.t("Discount")}
            </Typography>
          </Box>
          <Typography
            className={styles.billVal}
            sx={{
              fontSize: `${checkoutBillingPriceFontSize ?? "16"}px`,
              color: `${checkoutFontColor ?? "#000"} !important`,
            }}
          >
            {/* {currency} */}
            - {formatCurrency(discountAmount)}
          </Typography>
        </Box>)}
        {couponDiscountAmount > 0 && (<Box className={styles.listView} mb={1}>
          <Box className={styles.labelView}>
            <Typography
              className={styles.labelText}
              sx={{
                color: `${checkoutFontColor ?? "#000"} !important`,
              }}
            >
              {`Coupon (${couponName})`}
            </Typography>
          </Box>
          <Typography
            className={styles.billVal}
            sx={{
              fontSize: `${checkoutBillingPriceFontSize ?? "16"}px`,
              color: `${checkoutFontColor ?? "#000"} !important`,
            }}
          >
            {/* {currency} */}
            - {formatCurrency(couponDiscountAmount)}
          </Typography>
        </Box>)}
        <Box className={styles.listView}>
          <Box className={styles.listLabelView}>
            <Typography
              className={styles.billTitle}
              sx={{
                ...fontStyle1[restTemplate],
                color: `${checkoutFontColor ?? "#000"} !important`,
              }}
            >
              {i18next.t("Your bill")}
            </Typography>
          </Box>
          <Typography
            className={styles.totalVal}
            sx={{
              ...fontStyle1[restTemplate],
              color: `${checkoutFontColor ?? "#000"} !important`,
              fontSize: `${checkoutBillingTotalPriceFontSize ?? "19"}px`,
            }}
          >
            {/* {currency} */}
            {formatCurrency(totalCartPrice)}
          </Typography>
        </Box>
      </Box>
    </Grid>
  );
};

export default ARWebBilling;